import { readCookieValue, getDateFromString } from "./Utility";


var lastLogin = new Date();

export const defaultTimeout = 60 * 60 * 1000;
export const alertBeforeTimeout = (5 * 60 * 1000 - 10 * 1000);  //Timeout 10 sec before actual server timeout

interface Callback {
    (): any
}

interface CallbackRef {
    callback: Callback;
    timeoutRef: NodeJS.Timeout;
}

const callbacks: CallbackRef[] = [];

function getTimeOut(): number {
    var timeoutInMilliseconds = 0;

    let loginExpiresAt = getDateFromString(readCookieValue("Austrade.EMDG.LoginExpiresOn"), true);
    if (loginExpiresAt)
        timeoutInMilliseconds = loginExpiresAt.getTime() - new Date().getTime() - alertBeforeTimeout;

    if (timeoutInMilliseconds < 1) {
        timeoutInMilliseconds = defaultTimeout - alertBeforeTimeout;
    }

    return timeoutInMilliseconds;
}

export function addOnTimeout(callback: { (): any }) {
    let timeout = getTimeOut();

    let timeoutRef = setTimeout(callback, timeout);
    callbacks.push({ callback, timeoutRef });

    //console.log(`Added: ${timeoutRef} to len: ${callbacks.length}. Timeout = ${timeout} millli`)
}

export function removeOnTimeout(callback: { (): any }) {

    for (let i = 0; i < callbacks.length; i++) {
        if (callbacks[i].callback == callback) {
            clearTimeout(callbacks[i].timeoutRef);

            //console.log(`Removing: ${callbacks[i].timeoutRef}, len: ${callbacks.length}`)

            callbacks.splice(i, 1);
            return;
        }
    }
    throw new Error("Failed to find callback. Make sure you use the same callback to unsubscribe...")
}

export function resetOnTimeout() {
    let timeout = getTimeOut();
    for (let temp of callbacks) {

        //console.log(`Resetting from: ${temp.timeoutRef}, len: ${callbacks.length}`)

        clearTimeout(temp.timeoutRef);
        temp.timeoutRef = setTimeout(temp.callback, timeout);

        //console.log(`Resetting to: ${temp.timeoutRef}, len: ${callbacks.length}. Timeout = ${timeout} millli`)
    }
}